import { render, staticRenderFns } from "./ItemsArchivedTable.vue?vue&type=template&id=638484e2&scoped=true&"
import script from "./ItemsArchivedTable.vue?vue&type=script&lang=js&"
export * from "./ItemsArchivedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638484e2",
  null
  
)

export default component.exports